module.exports = __webpack_public_path__ + "static/roper-720f95aa1b5a9b85465d13ef68f3ec33.jpg";